export default __webpack_public_path__ + "static/media/142.c669dd80.jpg";